// @flow
import Centrifuge from 'centrifuge';

type TConnectionData = {
    url: string,
};

type TConnectionConfig = {
    connectionData: TConnectionData,
    onConnect: (context?: {}) => void,
    onDisconnect: () => void,
};

/**
 * connectionData урл центрифуги
 * centrifuge объект центрифуги
 * isConnected подключена ли центрифуна
 */
export class CentrifugeService {
    centrifuge: ?{
        channel: string,
        on(eventName: string, callback: () => void): void,
        subscribe(channelName: string, callback: () => void): void,
        unsubscribe(): void,
    };
    connectionData: ?{};
    isConnected: boolean;

    /**
     * конструктор
     */
    constructor() {
        this.centrifuge = null;
        this.connectionData = null;
        this.isConnected = false;
    }

    /**
     * Метод подключения к центрифуге
     * @param connectionData данные для подключения к центрифуге
     * @param onConnect коллбэк при подключении
     * @param onDisconnect коллбэк при дисконекте
     */
    connect({connectionData, onConnect, onDisconnect}: TConnectionConfig) {
        this.centrifuge = new Centrifuge(connectionData);
        if (this.centrifuge) {
            this.centrifuge.connect();
        }
        if (this.centrifuge) {
            this.centrifuge.on('connect', (context) => {
                onConnect(context);
                this.isConnected = true;
                this.connectionData = connectionData;
            });
        }
        if (this.centrifuge) {
            this.centrifuge.on('disconnect', onDisconnect);
        }
    }

    /**
     * Подписка на канал
     * @param channelName нвазвание канала
     * @param callback обработчики
     */
    subscribeChannel(channelName: string, callback: () => void) {
        if (this.isConnected) {
            this.startSubscribe(channelName, callback);
        }
    }

    /**
     * Подписка на канал
     * @param channelName название канала
     * @param callback нвазвание канала
     */
    startSubscribe(channelName: string, callback: () => void) {
        if (this.centrifuge) {
            this.centrifuge.subscribe(channelName, callback);
        }
    }
}
